import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { getSeriesLineAnnotations } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/line-annotations/line-annotations.selectors';
import { NAME_IN_LEGEND_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ backgroundColor: a0 });
function LineAnnotationsTabComponent_section_0_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const summaryLine_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(summaryLine_r4);
} }
function LineAnnotationsTabComponent_section_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5);
    i0.ɵɵelement(4, "span", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 7);
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9);
    i0.ɵɵlistener("click", function LineAnnotationsTabComponent_section_0_Template_div_click_8_listener() { const index_r2 = i0.ɵɵrestoreView(_r1).index; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.editAnnotationHandler.emit(index_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 10);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "div", 4)(11, "div", 11);
    i0.ɵɵtemplate(12, LineAnnotationsTabComponent_section_0_div_12_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r5 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(4, _c0, option_r5.color));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r5.label, " ");
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", option_r5.lineAnnotationsSummaryLines);
} }
function LineAnnotationsTabComponent_section_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section")(1, "div", 13)(2, "div", 14);
    i0.ɵɵelement(3, "br");
    i0.ɵɵtext(4, " Get Started.");
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Add securities, metrics, or a securitylist to annotate.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementEnd()()();
} }
export class LineAnnotationsTabComponent {
    constructor(store) {
        this.store = store;
        this.editAnnotationHandler = new EventEmitter();
        this.lineAnnotations = [];
        this.nameInLegend = NAME_IN_LEGEND_DEFAULT;
        this.calcInfo = {};
        this.securitiesInfo = {};
        this.isAlive = true;
        this.mapStateToComponent = (state) => {
            const { fundChart } = state;
            this.lineAnnotations = getSeriesLineAnnotations(state);
            this.calcInfo = state.calcInfo;
            this.nameInLegend = fundChart.nameInLegend;
            this.securitiesInfo = state.securitiesInfo;
        };
    }
    ngOnInit() {
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
}
LineAnnotationsTabComponent.ɵfac = function LineAnnotationsTabComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LineAnnotationsTabComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
LineAnnotationsTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LineAnnotationsTabComponent, selectors: [["ycn-line-annotations-tab"]], outputs: { editAnnotationHandler: "editAnnotationHandler" }, standalone: false, decls: 2, vars: 2, consts: [["class", "panel-sidebar-section panel-annotation-option", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "panel-sidebar-section", "panel-annotation-option"], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-row"], [1, "panel-sidebar-section-title", "chart-legend-item-title", "chart-bullet"], [1, "chart-bullet-point"], [1, "divider-vertical"], [1, "panel-sidebar-section-control"], ["ycnTooltip", "", "tooltipTitle", "Annotate", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click"], ["ycnIcon", "", "name", "icon-gear"], [1, "panel-sidebar-levels"], [4, "ngFor", "ngForOf"], [1, "panel-sidebar-section"], [1, "get-started"]], template: function LineAnnotationsTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LineAnnotationsTabComponent_section_0_Template, 13, 6, "section", 0)(1, LineAnnotationsTabComponent_section_1_Template, 9, 0, "section", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.lineAnnotations);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.lineAnnotations && ctx.lineAnnotations.length === 0);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.IconDirective, i4.TooltipDirective], encapsulation: 2 });
